














import { defineComponent, toRefs } from '@vue/composition-api';
import Tips from './tips.vue';
import { dynamicDestinationEditClick } from './../../../../track/edit-event';

const name = 'ttam-dynamic-destination-switch';
export default defineComponent({
  name,
  components: {
    Tips,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { isEdit } = toRefs(props);

    const onInput = (val: boolean) => {
      emit('input', val);
      isEdit.value && dynamicDestinationEditClick(val);
    };
    const handleCtaClick = () => {
      window.open(`https://ads.tiktok.com/help/article/considerations-for-video-shopping-ads-catalog?redirected=2`);
    };
    return {
      name,
      onInput,
      handleCtaClick,
    };
  },
});
